export type PlaybackSpeed = 0.5 | 0.75 | 1 | 1.25 | 1.5 | 2;

export const SPEED_OPTIONS: PlaybackSpeed[] = [0.5, 0.75, 1, 1.25, 1.5, 2];

export type PlaybackState = {
	isPlaying: boolean;
	currentTime: number;
	duration: number;
	playbackSpeed: PlaybackSpeed;
};

export type AudioState = {
	volume: number;
	isMuted: boolean;
};

export type UIState = {
	isFullscreen: boolean;
	showControls: boolean;
};

export type HLSPlayerContext = {
	// State
	playbackState: PlaybackState;
	audioState: AudioState;
	uiState: UIState;

	// Refs
	videoRef: React.RefObject<HTMLVideoElement | null>;
	containerRef: React.RefObject<HTMLDivElement | null>;

	// Methods
	togglePlay: () => void;
	seek: (time: number) => void;
	setVolume: (volume: number) => void;
	toggleMute: () => void;
	changeSpeed: (speed: PlaybackSpeed) => void;
	toggleFullscreen: () => void;
	handleMouseMove: () => void;
	handleMouseLeave: () => void;
	onDownloadVideoClick?: () => Promise<void>;
};

export type IControlsProps = {
	className?: string;
};
